<template>
    <div class="loading-bg">
        <div class="loading_main">
            <i></i>
        </div>
    </div>
</template>
<style>
    .loading-bg{
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        z-index:99999999;
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Chrome/Safari/Opera */
        -khtml-user-select: none; /* Konqueror */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently
    not supported by any browser */
    }
    .loading_main{
        position: fixed;
        width:50px;
        height:50px;
        z-index:999999999;
        left:50%;
        top:50%;
        margin-top:-25px;
        margin-left:-25px;
        background:rgba(0,0,0,0.5);
        border-radius:5px;
    }
    .loading_main i{
        background:url('../asset/images/pageload.png') no-repeat center center;
        display:block;
        width:50px;
        height:50px;
        animation:loading 1s infinite linear;
    }
    @-webkit-keyframes loading {
        0%{
            transform: rotate(0deg);
        }
        50%{
            transform: rotate(180deg);
        }
        100%{
            -webkit-transform: rotate(360deg);
        }
    }
</style>

<script>
    export default {
        data(){
            return{

            }
        },
        components:{

        },
        mounted(){

        },
        created(){

        },
        methods:{

        }
    }
</script>
